import React, { useState } from "react";
import { useEffect } from "react";
import LogoRic from "../../assets/img/logo/transparent-logo.png";
import LogoPunjab from "../../assets/img/logo/punjab-removebg-preview.png";

export default function ImagePopup() {
  const [visible, setVisible] = useState(true);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const Poster = () => (
    <>
      <style>{`
      @media (max-width: 600px) {
        .poster-root {
          width: 95vw !important;
        }

        .poster-root ul {
          font-size: clamp(8px, 3vw, 14px) !important;
          line-height: 1.8 !important;
        }

        .poster-root div,
        .poster-root span,
          .poster-root p {
          font-size: clamp(8px, 4vw, 8px) !important;
        }
          .poster-root title-text {
          font-size: clamp(8px, 4vw, 8px) !important;
          margin: 2px 5px !important;
        }

        .poster-root .header, .poster-root .footer {
          padding: 8px 10px !important;
        }

        .poster-root img {
          width: 40px !important;
          height: 40px !important;
          object-fit: contain !important;
        }

         table {
             font-size: clamp(8px, 4vw, 8px) !important;
            
          }

          table th,
          table td {
            padding: 6px !important;
          }
      }
    `}</style>
      <div
        className="poster-root"
        style={{
          fontFamily: "'Noto Nastaliq Urdu', serif",
          direction: "rtl",
          background: "#f5f5f5",
          width: "90vw",
          maxWidth: "900px",
          margin: "0 auto",
          boxSizing: "border-box",
        }}
      >
        {/* HEADER */}
        <div
          className="header"
          style={{
            background: "#0f8a8a",
            color: "white",
            padding: "12px 16px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <img src={LogoPunjab} alt="Punjab Logo" style={{ width: "60px", height: "60px", objectFit: "contain" }} />

          <div
            style={{
              fontWeight: "bold",
              fontSize: "clamp(16px, 2.5vw, 20px)",
              fontFamily: "sans-serif",
              textAlign: "center",
              flex: 1,
            }}
          >
            Rawalpindi Institute Of Cardiology
          </div>

          <img src={LogoRic} alt="RIC Logo" style={{ width: "60px", height: "60px", objectFit: "contain" }} />
        </div>
      </div>
      <div
        className="poster-root"
        style={{
          fontFamily: "'Noto Nastaliq Urdu', serif",
          direction: "rtl",
          background: "#f5f5f5",
          width: "90vw",
          maxWidth: "900px",
          margin: "0 auto",
          boxSizing: "border-box",
          padding: "10px",
        }}
      >
        {/* TITLE */}
        <div className="title-text" style={{ textAlign: "center", margin: "16px 10px" }}>
          <span
            style={{
              background: "#ddd",
              padding: "15px 20px",
              borderRadius: "25px",
              fontSize: "clamp(16px, 4vw, 24px)",
              color: "red",
              fontWeight: "bold",
              display: "inline-block",
            }}
          >
            ناقابل ضمانت جرم
          </span>
        </div>

        {/* NOTICE TEXT */}
        <div className="notice-text" style={{ padding: "0 16px", marginBottom: "20px", fontSize: "clamp(14px, 2.5vw, 18px)", lineHeight: 1.6 }}>
          <p>
            حکومت پاکستان پیمرا آرڈر نمبر <b>No.13(89)/OPS/2018/1374</b> <br />
            تاریخ <b>18 جون 2019</b> کے مطابق
          </p>

          <p style={{ color: "red", fontWeight: "bold", marginBottom: "10px" }}>
            تمام الیکٹرک اور پرنٹ میڈیا (اخبارات ٹی وی چینلز) کے نام پیمرا آرڈر کا پیغام
          </p>

          <p>
            سرکاری / پرائیویٹ ہسپتال میں کوئی بھی اخباری نمائندہ،ٹی وی چینل کا نمائندہ یا کوئی بھی عام شخص موبائل سے <b>Photo، Video</b> بنانے
            کا مجاز نہ ہے اور نہ کوئی خبر میڈیا پر چلا سکتا ہے۔
          </p>

          <p>
            علاج مناسب نہ ہونے کی صورت میں، مریض کے لواحقین اپنی شکایات متعلقہ ہیلتھ ڈیپارٹمنٹ یا انتظامیہ کو کر سکتے ہیں اور ساتھ اسٹام پیپر پر
            لکھ کر دینا ہوگا۔ شکایت غلط ثابت ہونے پر شکایت کنندہ کو قانون کے مطابق سزا ہو سکتی ہے۔ خلاف ضابطہ عمل پر مندرجہ ذیل سزائیں ہو سکتی
            ہے۔
          </p>
        </div>
        {/* TABLE */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "10px",
            fontSize: "clamp(14px, 2vw, 16px)",
            textAlign: "right",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#0f8a8a", color: "#fff" }}>
              <th style={{ border: "1px solid #000", padding: "8px" }}>نمبر شمار</th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>خلاف ضابطہ عمل</th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>سزائیں</th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>دفعات</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>01</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>ہسپتال کے کاموں میں مداخلت کرنا</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>2 سال قید با مشقت</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>353</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>02</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>ہسپتال میں ڈیوٹی پر مامور ڈاکٹرز/ نرسز/ وارڈ ملازم کے ساتھ غیر برتاؤ</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>2 سال قید با مشقت</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>509</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>03</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>ہسپتال کی حدود میں کسی بھی ورڈ ملازم/عملے کے ساتھ گالی گلوچ کرنا</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>2 سال قید با مشقت</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>504</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>04</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>کسی بھی طرح ڈاکٹرز/ نرسز /وارڈ ملازم کو دھمکانا</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>3 سال سے 7 سال قید با مشقت</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>506</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>05</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>کسی بھی انداز میں ڈاکٹرز/نرسز/ سٹاف وارڈ ملازم پر حملہ آور ہونا</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>3 سال سے 10 سال قید با مشقت</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>3328</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>06</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>کسی بھی ہسپتال کے اثاثہ جات/ املاک کو نقصان پہنچانا</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>3 سال قید با مشقت</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>333</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>07</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>ہسپتال کی حدود میں غیر ضروری ہجوم اکٹھا کرنا</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>6 سال تک قید با مشقت</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>141، 143</td>
            </tr>
          </tbody>
        </table>
      </div>{" "}
      <div
        className="poster-root"
        style={{
          fontFamily: "'Noto Nastaliq Urdu', serif",
          direction: "rtl",
          background: "#f5f5f5",
          width: "90vw",
          maxWidth: "900px",
          margin: "0 auto",
          boxSizing: "border-box",
        }}
      >
        {/* FOOTER */}
        <div
          className="footer"
          style={{
            background: "#0f8a8a",
            color: "white",
            padding: "10px 16px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            fontSize: "clamp(12px, 2vw, 14px)",
          }}
        >
          <div></div>
          <div>www.ricgop.online &nbsp;|&nbsp; Ph: 051-9281111-9</div>
        </div>
      </div>
    </>
  );

  const EnglishPoster = () => (
    <>
      <style>{`
      @media (max-width: 600px) {
        .poster-root {
          width: 95vw !important;
        }

        .poster-root ul {
          font-size: clamp(8px, 3vw, 14px) !important;
        }

        .poster-root div,
        .poster-root span,
        .poster-root p {
          font-size: clamp(8px, 4vw, 8px) !important;
        }

        .poster-root .title-text {
          font-size: clamp(8px, 4vw, 8px) !important;
          margin: 2px 5px !important;
        }

        .poster-root .header, .poster-root .footer {
          padding: 8px 10px !important;
        }

        .poster-root img {
          width: 40px !important;
          height: 40px !important;
          object-fit: contain !important;
        }

        table {
          font-size: clamp(8px, 4vw, 8px) !important;
        }

        table th,
        table td {
          padding: 6px !important;
        }
      }
    `}</style>
      <div
        className="poster-root"
        style={{
          fontSize: "10px",
          background: "#f5f5f5",
          width: "90vw",
          maxWidth: "900px",
          margin: "0 auto",
          boxSizing: "border-box",
        }}
      >
        {/* HEADER */}
        <div
          className="header"
          style={{
            background: "#0f8a8a",
            color: "white",
            padding: "12px 16px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <img src={LogoRic} alt="Punjab Logo" style={{ width: "60px", height: "60px", objectFit: "contain" }} />

          <div
            style={{
              fontWeight: "bold",
              fontSize: "clamp(16px, 2.5vw, 20px)",
              fontFamily: "sans-serif",
              textAlign: "center",
              flex: 1,
            }}
          >
            Rawalpindi Institute Of Cardiology
          </div>

          <img src={LogoPunjab} alt="RIC Logo" style={{ width: "60px", height: "60px", objectFit: "contain" }} />
        </div>
      </div>
      <div
        className="poster-root"
        style={{
          fontSize: "10px",
          background: "#f5f5f5",
          width: "90vw",
          maxWidth: "900px",
          margin: "0 auto",
          boxSizing: "border-box",
          padding: "10px",
        }}
      >
        {/* TITLE */}
        <div className="title-text" style={{ textAlign: "center", margin: "16px 10px" }}>
          <span
            style={{
              background: "#ddd",
              padding: "15px 20px",
              borderRadius: "25px",
              fontSize: "clamp(16px, 4vw, 24px)",
              color: "red",
              fontWeight: "bold",
              display: "inline-block",
            }}
          >
            Non-Bailable Offense
          </span>
        </div>

        {/* NOTICE TEXT */}
        <div
          className="notice-text"
          style={{ textAlign: "justify", padding: "0 16px", marginBottom: "20px", fontSize: "clamp(10px, 2.5vw, 10px)", lineHeight: 1.6 }}
        >
          <p>
            Government of Pakistan PEMRA Order No. <b>No.13(89)/OPS/2018/1374</b> <br />
            Date: <b>18 June 2019</b>
          </p>

          <p style={{ color: "red", fontWeight: "bold", marginBottom: "10px" }}>
            All electronic and print media (newspapers, TV channels) must follow PEMRA order message
          </p>

          <p>
            No reporter, TV channel representative, or any ordinary person is authorized to take <b>Photos or Videos</b> using mobile phones
            inside government/private hospitals or broadcast such news.
          </p>

          <p>
            In case of inadequate treatment, patient relatives can file complaints to the concerned health department or management with a
            written application on stamp paper. False complaints may lead to legal punishment. Violations are punishable as per below.
          </p>
        </div>

        {/* TABLE */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "10px",
            fontSize: "clamp(10px, 2vw, 14px)",
            textAlign: "right",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#0f8a8a", color: "#fff" }}>
              <th style={{ border: "1px solid #000", padding: "8px" }}>Serial No.</th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>Violation</th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>Punishment</th>
              <th style={{ border: "1px solid #000", padding: "8px" }}>Sections</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>01</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>Interference in hospital operations</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>2 years imprisonment with labor</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>353</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>02</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>Misbehavior with doctors/nurses/ward staff on duty</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>2 years imprisonment with labor</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>509</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>03</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>Abusing ward staff or employees within hospital premises</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>2 years imprisonment with labor</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>504</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>04</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>Threatening doctors/nurses/ward staff in any manner</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>3 to 7 years imprisonment with labor</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>506</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>05</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>Attacking doctors/nurses/staff ward in any manner</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>3 to 10 years imprisonment with labor</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>3328</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>06</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>Damaging hospital assets/property</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>3 years imprisonment with labor</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>333</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>07</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>
                Gathering unnecessary crowds or causing public disorder in hospital premises
              </td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>Up to 6 years imprisonment with labor</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>141, 143</td>
            </tr>
          </tbody>
        </table>
      </div>{" "}
      <div
        className="poster-root"
        style={{
          background: "#f5f5f5",
          width: "90vw",
          maxWidth: "900px",
          margin: "0 auto",
          boxSizing: "border-box",
        }}
      >
        {/* FOOTER */}
        <div
          className="footer"
          style={{
            fontSize: "10px",
            background: "#0f8a8a",
            color: "white",
            padding: "10px 16px",
            justifyContent: "space-between",
            fontSize: "clamp(8px, 2vw, 12px)",
          }}
        >
          <div></div>
          <div>www.ricgop.online &nbsp;|&nbsp; Ph: 051-9281111-9</div>
        </div>
      </div>
    </>
  );

  const slides = [
    {
      type: "component",
      content: <Poster />,
    },
    {
      type: "component",
      content: <EnglishPoster />,
    },
    {
      type: "image",
      src: "/assets/img/ImagePopup2.png",
    },
  ];

  const images = ["/assets/img/SecurityPopup.png", "/assets/img/ImagePopup2.png"];

  if (!visible) return null;

  const next = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prev = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        {/* Top Close */}
        <button style={styles.close} onClick={() => setVisible(false)}>
          ×
        </button>

        {/* Image */}
        {slides[current].type === "image" ? (
          <img src={slides[current].src} alt="Popup" style={styles.image} />
        ) : (
          <div style={styles.content}>{slides[current].content}</div>
        )}

        {/* Arrows */}
        <button style={styles.left} onClick={prev}>
          ‹
        </button>
        <button style={styles.right} onClick={next}>
          ›
        </button>

        {/* Bottom Close */}
        <button style={styles.closeBottom} onClick={() => setVisible(false)}>
          Close
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "10px",
  },
  card: {
    position: "relative",
    maxWidth: "900px",
    width: "100%",
    background: "#fff",
    borderRadius: "16px",
    overflow: "hidden",
  },
  image: {
    width: "100%",
    display: "block",
  },
  close: {
    position: "absolute",
    top: "10px",
    right: "15px",
    fontSize: "28px",
    color: "#fff",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    zIndex: 10,
  },
  closeBottom: {
    position: "absolute",
    bottom: "15px",
    right: "15px",
    padding: "8px 16px",
    background: "#000",
    color: "#fff",
    borderRadius: "8px",
    cursor: "pointer",
  },
  left: {
    position: "absolute",
    top: "50%",
    left: "10px",
    transform: "translateY(-50%)",
    fontSize: "30px",
    background: "rgba(0,0,0,0.5)",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    padding: "5px 10px",
  },
  right: {
    position: "absolute",
    top: "50%",
    right: "10px",
    transform: "translateY(-50%)",
    fontSize: "30px",
    background: "rgba(0,0,0,0.5)",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    padding: "5px 10px",
  },
};
